import {getRandomString} from '../../../../../../../util/string';

import {InputStringType} from './input-string-type';

export const DEFAULT_INPUT_STRING_VALUE: Array<InputStringType> = [{value: '', id: getRandomString()}];
